import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  query,
  where,
  collection,
  getDocs,
  orderBy,
  limit,
} from "firebase/firestore"
import { db, requestNotificationPermission, rtdb } from "../../Firebase/config"
import Tick from "../images/Done.svg"
import Notify from "../Componentslogic/Usenotifications"
import {
  FILTER_BY_ORDER_NUMBERS_DELIVERY,
  SelectFilterOrdernumbersDelivery,
} from "../../redux/actions/FilterProducts"
import { GetoneDeliveryorderHook } from "../Componentslogic/ReservationHook/Getonedeliveryorder"
import useFetchDriverOrders from "../Componentslogic/UsefetchcollectionDrivers"

const DriverPage = () => {
  const user = JSON.parse(localStorage.getItem("user"))
  const dispatch = useDispatch()
  const DeliveryorderData = useSelector(SelectFilterOrdernumbersDelivery)
  const { data: recentOrders } = useFetchDriverOrders(
    "DeliveryOrders",
    user?.name
  )

  const [loading, setLoading] = useState(true)

  const [lastFetchedTimestamp, setLastFetchedTimestamp] = useState(
    localStorage.getItem("lastFetchedTimestamp") || null
  )

  const [
    handleDonepreparing,
    handleDelete,
    disable,
    paid,
    handleOntheway,
    handleCheckDelivery,
    handleDelivered,
  ] = GetoneDeliveryorderHook(recentOrders)

  return (
    <div>
      <h1 className="d-flex justify-content-center mt-3">Your Orders</h1>

      <div className="Review-Container_orders_Staff ">
        {recentOrders.length > 0 ? (
          recentOrders.map((item, index) => (
            <div className="card mb-4" style={{ width: "100%" }} key={index}>
              <div className="mx-3">
                <div className="d-flex justify-content-center align-items-center ">
                  <h1>Order ID: {item.orderNumber}</h1>
                  {item.delivered && (
                    <img className="icon mx-2" src={Tick} alt="tick" />
                  )}
                </div>

                <div className="cart-items-container-driver">
                  <p>
                    <b>Name:</b> {item.userName}
                  </p>
                  <p>
                    <b>Phone:</b> {item.address?.contactNumber}
                  </p>
                  <div className="d-flex justify-content-around">
                    <p>
                      <b>Area:</b> {item.address?.area}
                    </p>
                    <p>
                      <b>Street:</b> {item.address?.street}
                    </p>
                  </div>
                  <div
                    className="d-flex justify-content-between"
                    style={{ textAlign: "center" }}
                  >
                    <p>
                      <b>Building Name:</b> {item.address?.buildingName}
                    </p>
                    <p>
                      <b>Apt:</b> {item.address?.aptNo}
                    </p>
                    <p>
                      <b>Floor:</b> {item.address?.floor}
                    </p>
                  </div>

                  {item.ConfirmedStaff &&
                  item.Donepreparing &&
                  !item.ontheWay ? (
                    <div
                      className="d-flex justify-content-center flex-column mt-4 mb-4"
                      style={{ gap: "10%" }}
                    >
                      <button
                        className="btns-Admin mb-4"
                        onClick={() => handleOntheway(item.id)}
                      >
                        Confirm
                      </button>
                    </div>
                  ) : (
                    !item.delivered && (
                      <div
                        className="d-flex justify-content-center flex-column mt-4 mb-4"
                        style={{ gap: "10%" }}
                      >
                        <button
                          className="btns-Admin mb-4"
                          style={{ backgroundColor: "#4caf50" }}
                          onClick={() =>
                            handleDelivered(
                              item.id,
                              item.userID,
                              item.totalAmount
                            )
                          }
                        >
                          Delivered
                        </button>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No orders available.</p>
        )}
      </div>
    </div>
  )
}

export default DriverPage
